import { isDef } from './utils'

export function forwardRef(vm, ref) {
  const vnode = vm.$vnode
  const key = vnode.data.ref
  if (!isDef(key)) return

  const ctx = vnode.context
  const refs = ctx.$refs

  if (vnode.data.refInFor) {
    const index = refs[key].indexOf(ref)
    if (index >= 0) {
      refs[key].splice(index, 1, ref)
    }
  } else {
    refs[key] = ref
  }
}
